import { render } from "./MemberMyProfile.vue?vue&type=template&id=20aeedd2&scoped=true"
import script from "./MemberMyProfile.vue?vue&type=script&lang=js"
export * from "./MemberMyProfile.vue?vue&type=script&lang=js"

import "./MemberMyProfile.vue?vue&type=style&index=0&id=20aeedd2&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20aeedd2"]])

export default __exports__